import { useState, useEffect } from "react";

import DynaLoader from "./DynaLoader";

import Button from "react-bootstrap/Button";

import { fetchCachedAccountDetails, subscribeToCachedAccount } from "../utils/LocalStorage";
import { isWalletAvailable } from "../utils/WalletProviders";
import { useConnectWallet } from "./WalletSelectionProvider";
import { handleError } from "../utils/ErrorHandler";
import * as Errors from '../utils/ErrorMessages';

const ConnectButton = (props: any) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isWalletInstalled, setIsWalletInstalled] = useState(false);
  const [isAccountConnectedVal, setIsAccountConnectedVal] = useState(false);

  const connect = useConnectWallet();

  useEffect(() => {
    let cancelled = false;

    // Follow the same connected account the nav uses, so connecting anywhere
    // updates everywhere -- this button used to check once on mount and never
    // hear about a connection made from the nav dropdown.
    const unsubscribe = subscribeToCachedAccount((accountDetails) => {
      if (!cancelled) {
        setIsAccountConnectedVal(accountDetails !== null);
      }
    });

    isWalletAvailable().then((available) => {
      if (cancelled) {
        return;
      }
      setIsWalletInstalled(available);
      setIsAccountConnectedVal(fetchCachedAccountDetails() !== null);
      setIsLoading(false);
    });

    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, []);

  const connectWallet = async () => {
    setIsLoading(true);

    try {
      // Success writes the cached account, which notifies the subscription above.
      const accountDetails = await connect();
      setIsWalletInstalled(true);
      setIsAccountConnectedVal(accountDetails !== null);
    } catch (err: any) {
      setIsWalletInstalled(err?.message !== Errors.DS_NO_ETH_WALLET);
      setIsAccountConnectedVal(false);

      handleError(err);
    } finally {
      setIsLoading(false);
    }
  }

  if (isLoading === true) {
    return <DynaLoader variant="small" />;
  }
  if (isWalletInstalled === false) {
    return (
      <Button target="_blank" rel="noreferrer" href="https://metamask.io">
        Install MetaMask
      </Button>
    );
  } else if (isAccountConnectedVal === true) {
    return (
      <Button variant="primary" onClick={props.mint} disabled={props.disabled}>
        Mint, baby!
      </Button>
    );
  } else {
    return <Button onClick={connectWallet}>Connect wallet</Button>;
  }
}

export default ConnectButton;
